import React from 'react'
import { CartIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CartIcon'
import { HarvestIcon } from '@frontend/pole-ui/lib/components/Icon/svg/HarvestIcon'
import { SellIcon } from '@frontend/pole-ui/lib/components/Icon/svg/SellIcon'
import { ServicesIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ServicesIcon'
import { WalletIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WalletIcon'
import { EUserProfileRoute } from '@/types'
import * as messages from './messages'
import type { TAdditionalSalesMenuSections } from './types'

export const sections: TAdditionalSalesMenuSections = [
  {
    title: messages.sections.buy.title,
    links: [
      {
        url: EUserProfileRoute.orders,
        icon: <CartIcon />,
        text: messages.sections.buy.orders,
      },
      {
        url: EUserProfileRoute.tenders,
        icon: <SellIcon />,
        text: messages.sections.buy.tenders,
      },
    ],
  },
  {
    title: messages.sections.sell.title,
    links: [
      {
        url: EUserProfileRoute.sales,
        icon: <HarvestIcon />,
        text: messages.sections.sell.orders,
      },
    ],
  },
  {
    title: messages.sections.another.title,
    links: [
      {
        url: EUserProfileRoute.fundingRequests,
        icon: <WalletIcon />,
        text: messages.sections.another.funding,
      },
      {
        url: EUserProfileRoute.agroserviceRequests,
        icon: <ServicesIcon />,
        text: messages.sections.another.services,
      },
    ],
  },
]
